/** Four-tab bar pinned to the bottom, above the home indicator. */

import { NavLink } from 'react-router-dom';
export { ROOT_PATHS, hasTabbar } from './tabbarPaths';
import { useI18n } from '../lib/i18n';
import { hapticSelection } from '../hooks/useTg';
import { Icon, type IconName } from './Icon';

export function Tabbar() {
  const { t } = useI18n();

  const tabs: { to: string; icon: IconName; label: string; fillWhenActive?: boolean }[] = [
    { to: '/', icon: 'home', label: t.home },
    { to: '/search', icon: 'search', label: t.search },
    { to: '/favorites', icon: 'heart', label: t.favorites, fillWhenActive: true },
    { to: '/profile', icon: 'user', label: t.profile },
  ];

  return (
    <nav
      data-fixed-chrome=""
      className="hairline-t fixed inset-x-0 bottom-0 z-30 flex bg-surface px-1 pt-1.5"
      style={{ paddingBottom: 'calc(var(--pv-space-2) + var(--pv-safe-bottom))' }}
      aria-label={t.appName}
    >
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.to === '/'}
          onClick={() => hapticSelection()}
          className="flex min-w-0 flex-1 flex-col items-center gap-0.5 py-1 transition-opacity duration-fast ease-pv active:opacity-55"
        >
          {({ isActive }) => (
            <>
              <Icon
                name={tab.icon}
                size={25}
                fill={isActive && tab.fillWhenActive}
                className={isActive ? 'text-accent' : 'text-hint'}
              />
              <span
                className={`max-w-[88px] truncate text-caption2 font-medium ${
                  isActive ? 'text-accent' : 'text-hint'
                }`}
              >
                {tab.label}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}

/** Spacer so page content can scroll clear of the fixed tab bar. */
export function TabbarSpacer() {
  return (
    <div
      aria-hidden="true"
      className="flex-none"
      style={{ height: 'calc(var(--pv-tabbar-height) + var(--pv-safe-bottom))' }}
    />
  );
}
